import { isEmpty, trim } from 'lodash';
// check if a string is empty or only whitespace
export const isEmptyWhitespace = (string) => isEmpty(trim(string));
export const isNotEmptyWhitespace = (string) => !isEmpty(trim(string));
